import styled from '@emotion/styled'

export const SubscriptionInvoicesListWrapper = styled.div`
  width: 100%;
`
